import React from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { confirmAlert } from 'react-confirm-alert';
import arrayMove from 'array-move';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Loader from 'features/Loader/Loader';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';
import { getClients } from 'features/home/ducks/clientActions';
import WorkoutSeries from './WorkoutSeries';
import WorkoutClient from './WorkoutClient';
import WorkoutMenu from './WorkoutMenu';
import { getWorkout, deleteWorkout, updateSeriesOrder } from '../../ducks/workoutActions';

class WorkoutDetails extends React.Component {
  constructor(props) {
    super(props);
    this.workoutId = props.match.params.id;
    this.state = {
      series: props.workout && props.workout.series,
      order: props.workout && props.workout.series_order || {}
    }
  }

  componentDidMount() {
    this.props.getWorkout(this.workoutId, this.props.history);
    this.props.getClients();
  }

  sortingSeries = (series, order={}) => {
    return series.sort((seriesItem1, seriesItem2) => {
      return (
        (order[`${seriesItem1.id}`] - order[`${seriesItem2.id}`])
        || seriesItem1.name.localeCompare(seriesItem2.name)
      );
    });
  }

  componentWillReceiveProps({workout}) {
    if(workout && workout.series) {
      this.setState({
        series: this.sortingSeries(workout.series, workout.series_order),
        order: workout.series_order || {}
      })
    }
  }


  handleConfirming = () => {
    this.props.deleteWorkout(this.workoutId);
    this.props.history.push('/workouts');
  };

  handleWorkoutDeletion = event => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure"
            text="you want to delete this workout?"
            cancelText="No"
            confirmText="Yes"
            onClose={onClose}
            handleConfirming={this.handleConfirming}
          />
        );
      }
    });
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    let oldSeries = this.state.series;
    let newSeries = arrayMove(oldSeries, oldIndex, newIndex);
    let newOrder = {};
    newSeries.forEach((seriesItem, index) => {
      newOrder[`${seriesItem.id}`] = index + 1;
    })
    this.setState({
      series: newSeries,
      order: newOrder
    });
    this.props.updateSeriesOrder(this.workoutId, newOrder);
  };

  render() {
    let { workout, clients, loading, loadingState } = this.props;
    let { series } = this.state;

    if (loading || loadingState) {
      return <Loader />;
    }

    return (
      <div className="workout-details">
        {workout && clients ? (
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
              <Breadcrumb.Item active>
                {workout && workout.name}
              </Breadcrumb.Item>
            </Breadcrumb>

            <div className="page-title">
              <h4>
                {workout && workout.name}{' '}
                <span>
                  {workout && `${workout.level} Phase ${workout.phase}`}
                </span>
              </h4>
              <div className="title-action">
                <i
                  className="fas fa-trash trash-icon"
                  onClick={this.handleWorkoutDeletion}
                ></i>
                <WorkoutMenu workoutId={this.workoutId} />
              </div>
            </div>

            <div className="plan-details-tab">
              <Tab.Container
                defaultActiveKey="seriesWorkout"
                transition={false}
                id=""
              >
                <Nav className="nav-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="seriesWorkout">Series</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="clientWorkout">Client</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="seriesWorkout">
                    {series && series.length && (
                      <WorkoutSeries
                        workoutId={this.workoutId}
                        series={series}
                        onSortEnd={this.onSortEnd}
                      />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="clientWorkout">
                    <WorkoutClient
                      workoutId={this.workoutId}
                      clientsId={workout.clients_id || []}
                      clients={clients}
                    />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    workout: state.workoutReducer.workout,
    clients: state.clientReducer.clients,
    loading: state.workoutReducer.loading,
    loadingState: state.clientReducer.loadingState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getWorkout: (workoutId, history) =>
      dispatch(getWorkout(workoutId, history)),
    deleteWorkout: workoutId => dispatch(deleteWorkout(workoutId)),
    getClients: () => dispatch(getClients()),
    updateSeriesOrder: (workoutId, seriesOrder) => dispatch(updateSeriesOrder(workoutId, seriesOrder))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutDetails);
